// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-button[data-v-4d3284a9] {\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 15px;\n  left: 13px;\n  color: #6A6D82;\n}\n.back-button .arrow-icon[data-v-4d3284a9] {\n  margin-right: 8px;\n}\n.back-button.dark[data-v-4d3284a9], .back-button .dark-invert[data-v-4d3284a9] {\n  color: #fff;\n}\n.back-button.dark .arrow-icon path[data-v-4d3284a9], .back-button .dark-invert .arrow-icon path[data-v-4d3284a9] {\n  stroke: #fff;\n}", ""]);
// Exports
module.exports = exports;
